import { render, staticRenderFns } from "./BlackGoldPopupNoticeLayer.vue?vue&type=template&id=3c780ff4"
import script from "./BlackGoldPopupNoticeLayer.vue?vue&type=script&lang=js"
export * from "./BlackGoldPopupNoticeLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports